import { render, staticRenderFns } from "./False.vue?vue&type=template&id=732a51e2&scoped=true"
import script from "./False.vue?vue&type=script&lang=js"
export * from "./False.vue?vue&type=script&lang=js"
import style0 from "./False.vue?vue&type=style&index=0&id=732a51e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a51e2",
  null
  
)

export default component.exports